import { render, staticRenderFns } from "./ErrorBar.vue?vue&type=template&id=04ac86c9&"
import script from "./ErrorBar.vue?vue&type=script&lang=ts&"
export * from "./ErrorBar.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports